import type {
  ConvertibleUnit,
  FormatOptions,
  Unit,
} from '@dynatrace-sdk/units';

import type { InverseTrendOptions } from '../../core/components/single-value-renderer/components/trend/types/inverse-trend-options.js';
import type { TrendIndicatorColors } from '../../core/components/single-value-renderer/components/trend/types/trend-indicator-colors.js';
import type { Formatter } from '../../core/types/formatter.js';

/**
 * Slot props for the trend component within SingleValueGrid.
 * @public
 */
export interface SingleValueGridTrendProps {
  /** Accessor to retrieve the trend direction. */
  directionAccessor?: string;
  /** Accessor to retrieve the trend value. */
  valueAccessor?: string;
  /** Accessor to retrieve the trend label. */
  labelAccessor?: string;
  /**
   * Determines whether to show the trend icon.
   * @defaultValue true
   */
  showIcon?: boolean;
  /** Overrides the colors of the trend icon and value for different trend directions.  */
  colorsOverride?: TrendIndicatorColors;
  /** Formatter options or function to format the trend value. */
  formatter?: Formatter | FormatOptions<Unit, ConvertibleUnit>;
  /** Accessor to retrieve the formatter options for the trend value. */
  formatterAccessor?: string;
  /**
   * Inverts 'upward' and 'downward' color options.
   * @defaultValue 'none'
   */
  inverseTrend?: InverseTrendOptions;
  /** Accessor to retrieve the inverse trend options. */
  inverseTrendAccessor?: string;
}

/**
 * @public
 */
export const Trend = (props: SingleValueGridTrendProps) => null;

Trend['displayName'] = 'SingleValueGrid.Trend';
